// ABOUTME: Statistics display component for hypothesis analysis metadata
// ABOUTME: Shows key metrics like evidence count, support rate, and controversy score

import React from 'react';
import { AnalysisMetadata } from '@/types/analysis';

interface StatisticsProps {
  metadata: AnalysisMetadata;
}

export const Statistics: React.FC<StatisticsProps> = ({ metadata }) => {
  // Helper function to safely format numbers
  const formatNumber = (value: any, isPercentage: boolean = false): string => {
    if (value === undefined || value === null) return 'N/A';
    if (typeof value === 'number' && !isNaN(value)) {
      if (isPercentage) {
        // Check if value is already a percentage (> 1) or a decimal (0-1)
        const percentage = value > 1 ? value : value * 100;
        return `${Math.round(percentage)}%`;
      }
      return value.toString();
    }
    return 'N/A';
  };

  const formatScore = (value: any): string => {
    if (value === undefined || value === null) return 'N/A';
    if (typeof value === 'number' && !isNaN(value)) {
      return value.toFixed(2);
    }
    return 'N/A';
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      <div className="bg-white rounded-lg p-4 shadow-md">
        <div className="text-sm text-gray-500 mb-1">Total Evidence</div>
        <div className="text-2xl font-bold text-gray-800">
          {formatNumber(metadata.total_evidence || metadata.evidence_points)}
        </div>
      </div>

      <div className="bg-white rounded-lg p-4 shadow-md">
        <div className="text-sm text-gray-500 mb-1">Support Rate</div>
        <div className="text-2xl font-bold text-green-600">
          {formatNumber(metadata.support_rate, true)}
        </div>
      </div>

      <div className="bg-white rounded-lg p-4 shadow-md">
        <div className="text-sm text-gray-500 mb-1">Controversy Score</div>
        <div className="text-2xl font-bold text-orange-600">
          {formatScore(metadata.controversial_score)}
        </div>
      </div>

      <div className="bg-white rounded-lg p-4 shadow-md">
        <div className="text-sm text-gray-500 mb-1">Groups Analyzed</div>
        <div className="text-2xl font-bold text-purple-600">
          {formatNumber(metadata.persona_count || metadata.total_personas)}
        </div>
      </div>
    </div>
  );
};
